import React from 'react'
import styled, { keyframes } from 'styled-components'

/* CONSTANTS */
import { CLIENT_STYLINGS, size } from '../../../utils/constants'

const loadingFade = keyframes`
  0% { opacity: 0; }
  50% {opacity: 0.8; }
  100% { opacity: 0; }
`

export const SearchOuterWrapper = styled.div`
  width: calc(100% - 2.5%);
  display: flex;
  flex-direction: column;

  @media (max-width: ${size.laptop}) {
    position: -webkit-sticky; /* Safari */
    position: sticky;
    top: 10px;
    z-index: 1;
    width: 100%;
  }
`

export const SearchBoxWrapper = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  padding-bottom: 15px;
  @media (max-width: ${size.laptop}) {
    width: unset;
  }
`
export const SearchWrapper = styled.input`
  position: relative;
  width: 100%;
  height: 45px;
  border: 1px solid
    ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER_100};
  border-radius: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].BORDERS_ROUNDED
      ? '3px'
      : '0px'};
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  padding: 12px 60px 12px 30px;
  resize: none;
  font-size: 18px !important;

  @media (max-width: ${size.laptop}) {
    font-size: 16px !important;
  }

  @media (max-width: ${size.mobileM}) {
    font-size: 16px !important;
  }

  &:focus {
    outline: none !important;
    border: 2px solid
      ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER_100};
  }
  &:hover {
    cursor: pointer;
  }
`

export const SearchIconWrapper = styled.div`
  z-index: 1;
  width: 30px;
  height: 45px;
  position: absolute;
  left: 2px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`

export const SubmitIconWrapper = styled.div`
  z-index: 1;
  width: 45px;
  height: 45px;
  position: absolute;
  right: 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`

export const SearchIconImage = styled.img`
  width: 25px;
  height: 25px;
  margin-top: 2px;
`
export const SelectedTripContainer = styled.div`
  display: flex;
  margin: 0 0 18px 0;
  overflow-x: scroll;
  flex-wrap: wrap;

  @media (max-width: ${size.laptop}) {
    margin: 0 0 18px 0;
  }
`

export const SelectedTripContainerBullet = styled.div`
  padding: 5px 12px;
  border-radius: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].BORDERS_ROUNDED
      ? '3px'
      : '0px'};
  border: 1px solid
    ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER_25};
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  text-align: left;
  background: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.SLATE_75};
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PAPER_00};
  &:hover {
    cursor: pointer;
  }
`

export const SelectedTripContainerBulletText = styled.span`
  font-size: 14px;
  margin-right: 5px;
  text-transform: capitalize;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PAPER_00};
`

export const SearchFiltersConatiner = styled.div`
  display: flex;
  margin: ${props => (props.extraPadding ? '0 0 40px 0' : '0 0 18px 0')};
  overflow-x: scroll;
  flex-wrap: wrap;

  @media (max-width: ${size.laptop}) {
    margin: ${props =>
      props.isHorizontal
        ? '0 0 0 0'
        : props.extraPadding
        ? '0 0 40px 0'
        : '0 0 18px 0'};
  }

  &::-webkit-scrollbar {
    display: none;
  }
`

export const SearchFiltersBullet = styled.div`
  padding: 5px 12px;
  border-radius: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].BORDERS_ROUNDED
      ? '3px'
      : '0px'};
  border: 1px solid
    ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER_25};
  display: flex;
  align-items: center;
  font-size: 12px;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  margin: 0 10px 10px 0;
  text-align: left;
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.SLATE_75};
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PAPER_00};

  &:hover {
    background-color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PAPER_00};
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.SLATE_100};
    cursor: pointer;
  }
`

export const SearchRecommendationsConatiner = styled.div`
  display: flex;
  margin: ${props => (props.extraPadding ? '0 0 40px 0' : '0 0 18px 0')};
  overflow-x: scroll;
  flex-wrap: wrap;

  @media (max-width: ${size.laptop}) {
    margin: ${props =>
      props.isHorizontal
        ? '0 0 0 0'
        : props.extraPadding
        ? '0 0 40px 0'
        : '0 0 18px 0'};
  }

  &::-webkit-scrollbar {
    display: none;
  }
`

export const SearchRecommendationsBullet = styled.div`
  padding: 5px 12px;
  border-radius: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].BORDERS_ROUNDED
      ? '3px'
      : '0px'};
  border: 1px solid
    ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER_25};
  display: flex;
  align-items: center;
  font-size: 12px;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  margin: 0 10px 10px 0;
  text-align: left;
  background: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PAPER_00};

  &:hover {
    background-color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.SLATE_75};
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PAPER_00};
    cursor: pointer;
  }
`

export const MessageAvatarContainer = styled.div`
  padding-top: 12px;
`

export const MayaMessageAvatar = styled.img`
  width: 30px;
  height: 30px;
  object-fit: fill;
  border-radius: 10px;
  min-width: 30px;
  min-height: 30px;
`

export const MessageContainer = styled.div`
  display: flex;
  align-self: flex-start;
  margin-bottom: 22px;
`

export const TextContainer = styled.div`
  width: ${props => (props.isTyping ? '5em' : 'unset')};
  height: ${props => (props.isTyping ? '2em' : 'unset')};
  position: relative;
  padding: 10px;
  margin-left: ${props => (props.isTyping ? '5px' : 'unset')};
  margin-top: ${props => (props.isTyping ? '8px' : 'unset')};
  border-radius: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].BORDERS_ROUNDED
      ? '20px'
      : '0px'};
`

export const TypingDot = styled.div`
  float: left;
  width: 6px;
  height: 6px;
  margin: 0 4px;
  background: rgba(0, 0, 0, 0.54);
  border-radius: 50%;
  opacity: 0;
  animation: ${loadingFade} 1s infinite;

  :nth-child(1) {
    animation-delay: 0s;
  }
  :nth-child(2) {
    animation-delay: 0.3s;
  }
  :nth-child(3) {
    animation-delay: 0.6s;
  }
`

export const AiResponseTextContainer = styled.div`
  text-align: left;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR
      .ASSISTANT_TEXT_MESSAGE_COLOR};
  font-size: 16px;
  line-height: 22px;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  white-space: pre-line;
  min-width: 50px;
  word-wrap: break-word;
  word-break: break-word;
  height: ${props => (props.$fullHeight ? 'unset' : '90px')};
  overflow: ${props => (props.$fullHeight ? 'unset' : 'hidden')};

  overflow-x: auto;

  table {
    border-collapse: collapse; /* Ensures borders are not doubled */
    width: 100%; /* Optional: Makes the table full width */
  }

  tr,
  th {
    border-bottom: 1px solid
      ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER_100}; /* Adds a border between rows */
  }

  th,
  td {
    padding: 8px; /* Adds spacing inside cells */
    text-align: left; /* Aligns text to the left */
  }

  /* Optional: Remove border from the last row */
  tr:last-child {
    border-bottom: none;
  }

  th {
    font-size: 14px;
    line-height: 22px;
    font-weight: 700;
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
    color: ${props =>
      props?.sender
        ? CLIENT_STYLINGS[props.theme.organizationSlug].COLOR
            .USER_TEXT_MESSAGE_COLOR
        : CLIENT_STYLINGS[props.theme.organizationSlug].COLOR
            .ASSISTANT_TEXT_MESSAGE_COLOR};
  }

  td {
    font-size: 14px;
    line-height: 22px;
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
    color: ${props =>
      props?.sender
        ? CLIENT_STYLINGS[props.theme.organizationSlug].COLOR
            .USER_TEXT_MESSAGE_COLOR
        : CLIENT_STYLINGS[props.theme.organizationSlug].COLOR
            .ASSISTANT_TEXT_MESSAGE_COLOR};
  }

  li p + ul,
  li p + ol {
    padding-top: 0 !important;
  }

  ol {
    padding-top: 10px;
    list-style-type: decimal;
    padding-inline-start: 20px;
    margin-block-start: 0px;
    margin-block-end: 0px;
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR
        .ASSISTANT_TEXT_MESSAGE_COLOR};
    font-size: 16px;
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
    white-space: normal;
  }

  ul {
    padding-top: 10px;
    padding-inline-start: 20px;
    margin-block-start: 0px;
    margin-block-end: 0px;
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR
        .ASSISTANT_TEXT_MESSAGE_COLOR};
    font-size: 16px;
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  }

  li {
    margin-block-start: 0px;
    margin-block-end: 0px;
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR
        .ASSISTANT_TEXT_MESSAGE_COLOR};
    font-size: 16px;
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
    white-space: normal;
    p {
      padding-bottom: 10px;
      display: block;
    }

    &::marker {
      font-size: 14px;
    }
  }

  li:not(:last-child) {
    padding-bottom: 10px;
  }

  li {
    li:not(:last-child) {
      padding-bottom: 10px;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    display: inline-block;
    margin-top: 10px;
    margin-bottom: 5px;
  }

  hr {
    display: none;
  }

  p {
    margin-block-start: 0px;
    margin-block-end: 0px;
    display: block;
    margin: 0px;
    padding: 0px;
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR
        .ASSISTANT_TEXT_MESSAGE_COLOR};
    font-size: 16px;
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  }

  a {
    color: #4183c4;
    text-decoration: none;
    background-color: transparent;
    font-size: 16px;
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  }

  strong {
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR
        .ASSISTANT_TEXT_MESSAGE_COLOR};
    font-size: 16px;
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
    font-weight: bold;
  }
`
